import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { cx, css } from 'emotion';
import ProcessCatalog from '../process/ProcessCatalog';
import { Panel } from 'react-bootstrap';
import Flexbox from 'flexbox-react';
import C3Chart from 'react-c3js';
import ProcessService from 'services/ProcessService';
import ModalsService from 'services/ModalsService';
import SecurityService from 'services/SecurityService';
import ProcessUtils from 'utils/ProcessUtils';
import $ from 'jquery';
import ToolbarItem from 'components/core/toolbar/ToolbarItem';
import Toolbar from 'components/core/toolbar/Toolbar';
import NavigationUtils from 'utils/NavigationUtils';
import ComponentUtils from 'utils/ComponentUtils';
import SiteFacilitiesService from 'services/SiteFacilitiesService';
import DodService from 'services/DodService';
import PermissionsModal from 'components/core/modals/PermissionsModal';
import HomePageCard from 'components/page/process-home/HomePageCard';
import ContactUs from 'components/core/header/ContactUs';
import Constants from 'utils/Constants';
import { colorTextBlack, getAnchorStyle } from 'styles/base.js';


const contentWrapper = css`
    max-width: 500px;
    padding: 30px 10px 0 0;
`;

const graphicWrapper = css`
    margin-bottom: 30px;
    display: flex;
    width: 330px;
    align-items: center;
    .c3-chart-arc text {
        fill: white
    }
    .c3-legend-item text {
        fill: ${colorTextBlack}
    }
`;

/**
 * The home view shows a filterable list of all the processes and some graphs with summary information.
 */
class ProcessHome extends React.Component {
    static propTypes = {
        processes: PropTypes.object,
        sortedIds: PropTypes.array,
        dispatch: PropTypes.func,
        userLoggedIn: PropTypes.bool,
        username: PropTypes.string,
        permissionsModal: PropTypes.object,
        users: PropTypes.object,
        processUIStateById: PropTypes.object
    };

    constructor(props) {
        super();

        // Make sure supporting information is loaded in the background for use in typeaheads
        SiteFacilitiesService.fetchSiteFacilitiesIfNeeded();
        DodService.fetchDodsIfNeeded();

        // Make sure the processes are loaded
        ProcessService.fetchProcessesIfNeeded();
    }

    onDoubleClick = (e) => {
        // Get the process ID for the selected element
        const selectedProcess = $(e.target).closest('[data-name]');
        const processId = selectedProcess.data('name');
        NavigationUtils.gotoProcess(processId);
    };

    onWizardClick = () => {
        // create a new process with a unique id
        const baseName = Constants.PROCESS_WIZARD_NEW_NAME;
        let tempName = baseName;
        let number = 0;

        while (this.props.processes[tempName]) {
            number++;
            tempName = `${baseName}_${number}`;
        }

        //const data = this.getTestData(tempName);
        const data = this.getNewProcessData(tempName);

        ProcessService.newProcess(tempName, data, false);
        NavigationUtils.gotoWizardMode(tempName);
    };

    onContextMenuClicked = (e, data) => {
        switch (data.action) {
            case 'open':
                Object.keys(data.selectedItems).forEach((key) => {
                    NavigationUtils.gotoProcess(key);
                });
                break;
            case 'delete':
                this._deleteProcesses(data);
                break;
            case 'permissions':
                this.viewPermissions(data);
                break;
            case 'revisions':
                Object.keys(data.selectedItems).forEach((key) => {
                    NavigationUtils.gotoProcessRevisionHistory(key);
                });
                break;
            case 'dependencies':
                Object.keys(data.selectedItems).forEach((key) => {
                    NavigationUtils.gotoDependencyTree(key, true);
                });
                break;
            case 'wizard':
                let processId = Object.keys(data.selectedItems)[0];
                NavigationUtils.gotoWizardMode(processId);
                break;
            case 'run':
                processId = Object.keys(data.selectedItems)[0];
                NavigationUtils.gotoRunCode(processId);
                break;
            default:
                break;
        }
    };

    onContactUsClicked = () => {
        window.location.href = 'mailto:adisupport@arm.gov';
    };

    getNewProcessData(tempName) {
        const data = {
            name: tempName,
            type: Constants.PROCESS_TYPE_VAP,
            processing_interval: '86400',
            output_interval: {},
            description: '',
            notification_email: ProcessUtils.getCurrentUserEmail(),
            email_errors: true,
            email_warnings: false,
            run_locations: [],
            ui_state: {
                data_locations: {
                    user_folder: ProcessUtils.getProcessDefaultUserFolder(),
                    use_user: false,
                    use_archive: true,
                    use_test: false
                },
            },
            input_datastreams: [],
            output_datastreams: [],
            variable_retrieval: {
                input_datasets: {},
                retrieved_variables: {},
                coordinate_systems: {},
                output_datastream_variable_mappings: {}
            }
        };
        return data;
    }

    getTestData(tempName) {
        const data = {
            name: tempName,
            type: Constants.PROCESS_TYPE_VAP,
            processing_interval: '86400',
            description: '',
            notification_email: ProcessUtils.getCurrentUserEmail(),
            email_errors: true,
            email_warnings: false,
            run_locations: [
                { site: 'SGP', fac: 'B1' }
            ],
            data_locations: {
                user_folder: ProcessUtils.getProcessDefaultUserFolder(),
                use_user: false,
                use_archive: true,
                use_test: false
            },
            input_datastreams: ['05okm.b1'],
            output_datastreams: [],
            variable_retrieval:
                {
                    input_datasets:
                        {
                            '05okm_b1': {
                                name: '05okm_b1',
                                offsets: [
                                    0,
                                    0
                                ],
                                rules: [
                                    {
                                        priority: 1,
                                        run_location: {
                                            site: 'RUN_LOCATION',
                                            fac: null
                                        },
                                        run_time: {
                                            start: 'ANY_TIME',
                                            end: 'ANY_TIME'
                                        },
                                        data_location: {
                                            site: 'RUN_LOCATION',
                                            fac: null
                                        },
                                        datastream_name: '05okm.b1',
                                        variable_mappings: {
                                            pres: [
                                                'pres'
                                            ]
                                        }
                                    }
                                ]
                            }
                        },
                    retrieved_variables: {
                        pres: {
                            name: 'pres',
                            data_type: 'float',
                            units: 'hPa',
                            variable_required: 1,
                            retrieve_qc_variable: 0,
                            qc_variable_required: 0,
                            input_dataset: '05okm_b1',
                            coordinate_system: null,
                            dims: [
                                'time',
                                'platform'
                            ]
                        }
                    },
                    coordinate_systems: {},
                    output_datastream_variable_mappings: {}
                }
        };
        return data;
    }


    countProcessesByType(type) {
        let count = 0;
        for (const name of Object.keys(this.props.processes)) {
            const value = this.props.processes[name];
            if (value.type === type) {
                count++;
            }
        }
        return count;
    }

    isContextMenuItemDisabled = (menuItem, processName, selectedItems) => {
        let disabled = false;

        if (menuItem === 'Delete') {
            //check that the process selected isn't 'prod'
            disabled = !this.props.userLoggedIn || this.props.processes[processName].prod ||
                !ProcessUtils.canCurrentUserEditProcess(processName, this.props.processes[processName].deprecated);

        } else if (menuItem === 'Permissions') {
            if (Object.keys(selectedItems).length > 1) {
                disabled = true;
            } else {
                disabled = !this.props.userLoggedIn;
            }

        } else if ((menuItem === 'Open in Wizard' || menuItem === 'Run Data Consolidator')
            && Object.keys(selectedItems).length > 1) {
            // can only run or open in wizard one at a time
            disabled = true;
        }

        return disabled;
    };

    _deleteProcesses(data) {
        // First check that the selected items do not contain any production processes
        const prodProcs = [];
        const procsToDelete = [];
        let procsStr = '';
        Object.keys(data.selectedItems).forEach((key) => {
            if (this.props.processes[key].prod) {
                prodProcs.push(key);
            } else {
                procsToDelete.push(key);
                if (procsStr) {
                    procsStr = `${procsStr}, ${key}`;
                } else {
                    procsStr = key;
                }
            }
        });

        const warningOk = () => {
            if (procsToDelete.length > 0) {
                // Pop up confirmation dialog
                const deleteOk = () => {
                    Object.keys(data.selectedItems).forEach((processId) => {
                        ProcessService.deleteProcess(processId);
                    });
                };

                ModalsService.openModal({
                    id: 'confirm_delete_processes',
                    modalType: ModalsService.TYPE_CONFIRM,
                    modalTitle: 'Confirm Delete',
                    modalMessage: `Are you sure you want to delete: ${procsStr}?`,
                    onOk: deleteOk
                });
            }
        };

        // pop up error message if production processes are selected
        if (prodProcs.length > 0) {
            let type = 'Process';
            let verb = 'it is';
            if (prodProcs.length > 1) {
                type = 'Processes';
                verb = 'they are';
            }
            const prodProcsStr = prodProcs.reduce((sum, value) => {
                if (sum) {
                    return `${sum}, ${value}`;
                } else {
                    return value;
                }
            }, '');
            ModalsService.openModal({
                id: 'process_delete_warning',
                modalType: ModalsService.TYPE_ERROR,
                modalTitle: 'Delete Error',
                modalMessage: `${type}: ${prodProcsStr} will not be deleted because ${verb} in PRODUCTION.`,
                onOk: warningOk
            });
        } else {
            warningOk();
        }
    }

    viewPermissions = (data) => {
        // Make sure the users and owners are loaded into the store
        ComponentUtils.openPermissionsModal(data.name);

        SecurityService.fetchUsersIfNeeded();
        ProcessService.fetchProcessOwnersIfNeeded(data.name);
    };

    render() {
        const data = {
            columns: [
                ['Ingests', this.countProcessesByType('Ingest')],
                ['VAPS', this.countProcessesByType('VAP')]
            ],
            type: 'pie'
        };

        const pie = {
            label: {
                format: (value, ratio, id) => {
                    return value;
                }
            }
        };

        const size = {
            width: 150,
            height: 150
        };

        const contextMenuItems = [
            {
                label: 'Open',
                data: { action: 'open' },
                disabled: false
            },
            {
                label: 'Open in Wizard',
                data: { action: 'wizard' }
            },
            {
                label: 'Run Data Consolidator',
                data: { action: 'run' }
            },
            {
                label: 'Delete',
                data: { action: 'delete' }
            },
            {
                label: 'Permissions',
                data: { action: 'permissions' }
            },
            {
                label: 'Revision History',
                data: { action: 'revisions' },
                disabled: false
            },
            {
                label: 'Dependencies',
                data: { action: 'dependencies' },
                disabled: false
            }

        ];

        let permissionsModalComponent = null;
        if (this.props.permissionsModal.open) {
            permissionsModalComponent = (
                <PermissionsModal
                    processId={this.props.permissionsModal.processId}
                />
            );
        }

        const contactUsStyle = css`
            .main-menu-item a {
                ${getAnchorStyle('rgba(0, 0, 0, 0.65)')}
            }
        `;

        return (
            <div className="home page">
                <div className="green-bar"/>
                <div className="content flex-row full">
                    <div className="left-pane">
                        <Toolbar className="home">
                            <ToolbarItem
                                title="New Process"
                                className="fa fa-lg fa-plus new"
                                clickHandler={ProcessUtils.addProcess}
                                enabled={this.props.userLoggedIn}
                                showText
                            />
                            <ToolbarItem
                                title="New Process Wizard"
                                className="fa fa-lg fa-magic new"
                                clickHandler={this.onWizardClick}
                                enabled={this.props.userLoggedIn}
                                showText
                            />
                        </Toolbar>
                        <Panel>
                            <Panel.Heading>
                                Process Catalog
                            </Panel.Heading>
                            <Panel.Body>
                                <ProcessCatalog
                                    id="process-catalog"
                                    sortedIds={this.props.sortedIds}
                                    data={this.props.processes}
                                    onDoubleClick={this.onDoubleClick}
                                    onContextMenuItemClicked={this.onContextMenuClicked}
                                    isContextMenuItemDisabled={this.isContextMenuItemDisabled}
                                    contextMenuItems={contextMenuItems}
                                    contextMenuId="processCatalogItemContextMenu"
                                    filterable
                                    className={css`.filtered-list-container {width:100%;}`}
                                />
                            </Panel.Body>
                        </Panel>
                    </div>
                    <div className="right-pane">
                        <Flexbox flexDirection="column" className={contentWrapper} alignItems="center">

                            <div className={graphicWrapper}>
                                <div className={css`margin-top: 15px;`}> The PCM Process Manager allows you to create
                                    and configure an ARM Data Integrator(ADI) application.
                                </div>
                                <C3Chart data={data} pie={pie} size={size} unloadBeforeLoad/>
                            </div>

                            <HomePageCard iconClass="fa-book"
                                onClick={NavigationUtils.openExternalLinkInNewWindowFunc('https://engineering.arm.gov/ADI_doc/')}>
                                <span>Learn more about ADI</span>
                            </HomePageCard>
                            <HomePageCard iconClass="fa-search"
                                onClick={NavigationUtils.gotoSearchFunc()}>
                                <span>Search code catalog</span>
                            </HomePageCard>
                            <HomePageCard iconClass="fa-code"
                                onClick={NavigationUtils.openExternalLinkInNewWindowFunc('https://code.arm.gov/')}>
                                <span>Browse code.arm.gov</span>
                            </HomePageCard>
                            <HomePageCard iconClass="fa-envelope-open" className={cx('contact-us-card', contactUsStyle)}>
                                <ContactUs
                                    username={this.props.username}
                                    users={this.props.users}
                                    icon={false}
                                />
                            </HomePageCard>
                            <HomePageCard iconClass="fa-list-ol"
                                onClick={NavigationUtils.gotoTutorialsFunc(false)}>
                                <span>PCM Tutorial Series</span>
                            </HomePageCard>
                        </Flexbox>
                    </div>
                </div>
                {permissionsModalComponent}
            </div>
        );
    }
}

// Automatically pull state information from the store and
// pass it to this component as props
const mapStateToProps = (storeState) => {
    const processState = ProcessService.getMyState(storeState);
    const securityState = SecurityService.getMyState(storeState);
    const modalsState = ModalsService.getMyState(storeState);

    return {
        userLoggedIn: securityState.userLoggedIn,
        username: securityState.username,
        processes: processState.processesById,
        sortedIds: processState.sortedIds,
        users: securityState.users,
        processOwnersById: processState.processOwnersById,
        processUIStateById: processState.processUIStateById,
        permissionsModal: modalsState.permissionsModal
    };
};

export default connect(mapStateToProps)(ProcessHome);



// WEBPACK FOOTER //
// ./src/components/page/process-home/ProcessHome.js